import isAvailable from './isAvailable';
import toCapitializeForm from './toCapitializeForm';

const getMealInfo = boardType =>
  isAvailable(boardType.key) ? `\n${toCapitializeForm(boardType.key)} - ${boardType.label}` : '';

export default getMealInfo;
